import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { MasterService } from "src/app/components/master/services/master-service";

@Component({
  selector: "app-widgets-kpi",
  templateUrl: "./widgets-kpi.component.html",
  styleUrls: ["./widgets-kpi.component.scss"],
})
export class WidgetsKPIComponent implements OnInit, OnChanges {
  @Input() districtId;
  @Input() kpiData;

  constructor(private masterService: MasterService) {}
  TotalGrievanceReceived: number;
  TotalGrievancePending: number;
  TotalGrievanceClosed: number;
  TotalYearlyReceived: number;
  TotalYearlyPending: number;
  TotalYearlyClosed: number;
  TotalMonthlyRecevied: number;
  TotalMonthlyPending: number;
  TotalMonthlyClosed: number;

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.getKpiValue();
  }
  getKpiValue() {
    if (this.kpiData && this.kpiData.TotalGrievance) {
      this.TotalGrievanceReceived = this.kpiData.TotalGrievance.totalReceived;
      this.TotalGrievancePending = this.kpiData.TotalGrievance.totalPending;
      this.TotalGrievanceClosed = this.kpiData.TotalGrievance.totalClosed;
    }
    if (this.kpiData && this.kpiData.TotalYearlyGrievance) {
      //yearly count of grievances//
      this.TotalYearlyReceived =
        this.kpiData.TotalYearlyGrievance.totalReceived;
      this.TotalYearlyPending = this.kpiData.TotalYearlyGrievance.totalPending;
      this.TotalYearlyClosed = this.kpiData.TotalYearlyGrievance.totalClosed;
    }
    if (this.kpiData && this.kpiData.TotalMonthlyGrievance) {
      //montly count of grievances//
      this.TotalMonthlyRecevied =
        this.kpiData.TotalMonthlyGrievance.totalReceived;
      this.TotalMonthlyPending =
        this.kpiData.TotalMonthlyGrievance.totalPending;
      this.TotalMonthlyClosed = this.kpiData.TotalMonthlyGrievance.totalClosed;
    }
  }
}
